import { useState, useEffect, useCallback } from 'react';
import { deploymentsApi } from '@infrastructure/api/deploymentsApi';
export function useDeploymentStatus(deploymentId) {
    const [deployment, setDeployment] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchDeployment = useCallback(async () => {
        if (!deploymentId)
            return;
        setIsLoading(true);
        setError(null);
        try {
            const data = await deploymentsApi.getStatus(deploymentId);
            setDeployment(data);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : 'Failed to load deployment';
            setError(message);
        }
        finally {
            setIsLoading(false);
        }
    }, [deploymentId]);
    useEffect(() => {
        fetchDeployment();
    }, [fetchDeployment]);
    return {
        deployment,
        isLoading,
        error,
        refetch: fetchDeployment,
    };
}
export function usePrototypeDeployments(prototypeId, options) {
    const [deployments, setDeployments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [total, setTotal] = useState(0);
    const fetchDeployments = useCallback(async () => {
        if (!prototypeId)
            return;
        setIsLoading(true);
        setError(null);
        try {
            const { deployments: data, total: totalCount } = await deploymentsApi.listForPrototype(prototypeId, options);
            setDeployments(data);
            setTotal(totalCount);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : 'Failed to load deployments';
            setError(message);
        }
        finally {
            setIsLoading(false);
        }
    }, [prototypeId, options?.status, options?.limit, options?.offset]);
    useEffect(() => {
        fetchDeployments();
    }, [fetchDeployments]);
    // Auto-refresh functionality for active deployments
    useEffect(() => {
        if (!options?.autoRefresh)
            return;
        const hasActiveDeployments = deployments.some((deployment) => deployment.status === 'pending' ||
            deployment.status === 'building' ||
            deployment.status === 'deploying');
        if (!hasActiveDeployments)
            return;
        const interval = setInterval(fetchDeployments, options.refreshInterval || 10000 // Default 10 seconds
        );
        return () => clearInterval(interval);
    }, [deployments, options?.autoRefresh, options?.refreshInterval, fetchDeployments]);
    return {
        deployments,
        isLoading,
        error,
        total,
        refetch: fetchDeployments,
    };
}
